import React from 'react';
import { noInfoTasks } from 'constants';
import MDTypography from 'components/MDTypography';
import { useRenderNoInfo } from 'utils/commonUtils';
import { cardListColors } from '../../DashboardUtils';
import { ListItemWrap, StatusDot } from '../dashboardStyled';

const DashboardTasks = (props) => {
  const { taskList } = props;

  const noInfoComponent = useRenderNoInfo(taskList?.items, noInfoTasks);

  return (
    <>
      {noInfoComponent}
      {taskList?.items?.map((item, index) => {
        const dotColor = cardListColors[index % cardListColors.length];
        return (
          <ListItemWrap key={index}>
            <StatusDot bgcolor={dotColor} />
            <MDTypography variant="button" color="text">
              {item.title}
            </MDTypography>
          </ListItemWrap>
        );
      })}
    </>
  );
};

export default DashboardTasks;
